import axios from 'axios';
import { apiPaths, preciousChildPaths } from 'constants/path';
import { apiKeyHeader, tokenHeader } from 'functions/apiFunctions';
import { PaymentResult, purchaseCounselingResponse, purchaseCounselingRqData } from 'models/MindUp/purchaseCounselingApiTypes';
import { HospitalResponseType } from 'models/PreciousChild/holidayResponseType';
import moment from 'moment';

class MindUpHolidayApi {
    async getHoliday(): Promise<HospitalResponseType> {
        function getAfterTwoDayDate(today: Date) {
            const todayDate = new Date(today);
            const afterTwoDay = todayDate.setDate(today.getDate() + 2);
            return moment(afterTwoDay).format('YYYYMMDD');
        }

        function getAfterOneMonth(today: Date) {
            const afterOneMonth = moment(today).add(1, 'month').format('YYYYMMDD');
            return afterOneMonth;
        }

        try {
            const response = await axios.get(`${apiPaths.getHolidays}?startDate=${getAfterTwoDayDate(new Date())}&endDate=${getAfterOneMonth(new Date())}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `${process.env.REACT_APP_AUTH_KEY}`,
                },
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async findPaymentInfo(paymentId: string): Promise<purchaseCounselingResponse> {
        try {
            const response = await fetch(`https://api.tlchealthcare.co.kr/sms/payment/getInfo/${paymentId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `${process.env.REACT_APP_AUTH_KEY}` },
            });

            return await response?.json();
        } catch (error) {
            throw error;
        }
    }

    async findPaymentResultByMchtTrdNo(mchtTrdNo: string): Promise<PaymentResult> {
        try {
            const response = await axios.get(`https://api.tlchealthcare.co.kr/sms/concierge/getCsPaymentResult/${mchtTrdNo}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `${process.env.REACT_APP_AUTH_KEY}`,
                },
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }
}
export const mindUpHolidayApi = new MindUpHolidayApi();
